export default __webpack_public_path__ + "static/media/1403.2053e797.png";